$(document).ready(function () {
    let isAmountAdjust = !1;
    window.veriff = {
        result: null
    }

    function setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/"
    }
    $(".appoinment_icon_wrapp .appoinment_contant_wrapp.without_homepage_header a").click(function () {
        setCookie("appointmentform", "appointmentform", 1)
    });
    $(".main_claculator-right-part .right-side-bottom a.btn").click(function () {
        setCookie("appointmentform", "appointmentform", 1)
    });
    $(".custom-first-menu-here").click(function () {
        $(this).parents("li.slide-nav__item").toggleClass("active-menu")
    });
    // jQuery.getJSON("/cart.js", function (cart) {
    //     var original_price = cart.total_price,
    //         total_goal = $(".sidebar_progress_bar").attr("data-goal"),
    //         final_result = original_price / 100
    //     if (final_result >= total_goal) {
    //         $("span.minus_val").hide();
    //         $(".free_shipping_text").show()
    //     }
    //     else if (final_result < total_goal) {
    //         $(".free_shipping_text").hide()
    //     }
    // });
    $("ul.site-nav li.site-nav--has-dropdown").mouseleave(function () {
        $("body").removeClass("on_header_hover")
    });
    $("ul.site-nav li.site-nav--has-dropdown").mouseenter(function () {
        $("body").addClass("on_header_hover")
    });
    $(document).on("change", "input[type=date]", function () {
        var data_value_get = $(this).val();
        if (data_value_get !== "") {
            $(this).removeClass("placeholder_shown");
            $(this).addClass("placeholder_hide")
        }
        else {
            $(this).addClass("placeholder_shown");
            $(this).removeClass("placeholder_hide")
        }
    });
    $(document).on("focus", "input[type=date]", function () {
        var data_value_get = $(this).val();
        if (data_value_get !== "") {
            $(this).removeClass("placeholder_shown");
            $(this).addClass("placeholder_hide")
        }
        else {
            $(this).addClass("placeholder_shown");
            $(this).removeClass("placeholder_hide")
        }
    });
    var disabledDates = ["2024-07-29", "2024-07-30", "2024-07-31", "2024-08-01", "2024-08-02", "2024-08-03", "2024-08-04", "2024-08-05", "2024-08-06",
        "2024-08-07", "2024-08-08", "2024-08-09", "2024-08-10", "2024-08-11", "2024-08-12", "2024-08-13", "2024-08-14", "2024-08-15", "2024-08-16",
        "2024-08-17"
    ];


    //   $('#datepic_client_date, #second_datepic_client_date').datepicker({
    //     minDate: new Date(),
    //     dateFormat: "yy-mm-dd",
    //     beforeShowDay: function (date) {
    //         var dayOfWeek = date.getDay();
    //         var formattedDate = $.datepicker.formatDate('yy-mm-dd', date);
    //         var today = new Date();
    //         var isToday = formattedDate === $.datepicker.formatDate('yy-mm-dd', today);
    //         var isDisabledDate = disabledDates.indexOf(formattedDate) !== -1;
    //         var isWeekend = (dayOfWeek === 0 || dayOfWeek === 1);

    //      //   console.log("Agency:", $("#agency-id").val());
    //      //   console.log("Agency option:", $("#agency-id option:selected").val());
    //      //   console.log("Closures:", agencyClosures.length);
    //                     /* ---------------------------------------
    //            NEW : Agency Holiday Check
    //         --------------------------------------- */
    //     var selectedAgency = $("#agency-id option:selected").val() || "";
    //         if (selectedAgency && agencyClosures.length > 0) {
    //             var holiday = isAgencyClosed(selectedAgency, formattedDate);
    //             if (holiday.status) {
    //                 return [false, "disabled", "Agency Closed"];
    //             }
    //         }
    //         /* --------------------------------------- */
    //         if (
    //             (isToday && isWeekend) ||
    //             isDisabledDate ||
    //             isWeekend
    //         ) {
    //             return [false, "disabled"];
    //         }
    //         return [true, ""];
    //     },
    //         onSelect: function(dateText) {
    //             console.log("******** onSelect Fired ********");
    //             console.log("dateText:", dateText);
    //             $("#formatted_date").val(dateText);
    //             $("#second_formatted_date").val(dateText);
    //             console.log("Hidden:", $("#formatted_date").val());
    //         }
    // });
});

function addJsScript(src) {
    var script = document.createElement("script");
    script.src = src;
    document.head.appendChild(script)
}

// ============================================
// CART ADJUSTMENT LOGIC - FIXED VERSION
// Only calls change.js when clicking outside input
// ============================================
let thisElement = null;
let isAmountAdjusting = false;
let isLoadingAdjuster = false;
let isFistTimePageLoad = true;
let pendingUpdates = new Map(); // Track items that need updating with their data

$(document).ready(function () {
    adjustAmount(true);
    
    $(document).on("CartDrawer:open drawerOpen ajaxProduct:added", () => {
        adjustAmount(false);
    });
    
    $(document).on("cart:updated", () => {
        console.log("cart:updated");
        adjustAmount(false);
        if (!isFistTimePageLoad) {
            setTimeout(() => {
                window.location.reload();
            }, 500);
        }
    });
    
    // Handle typing in the adjust value input
    $(".adjust-value").on("keyup", function (e) {
        isAmountAdjusting = true;
    });
    
    // FIXED: Only update attributes on change, do NOT call change.js yet
    $(".adjust-value").on("change", function (e) {
        const $input = $(this);
        const itemKey = $input.parents(".cart__item").data("key");
        
        isAmountAdjusting = true;
        
        let newVal = parseFloat($input.val().replace(/[^0-9.]/g, "").replace(/(\..*?)\..*/g, "$1"));
        let itemAmount = parseFloat($input.data("value"));
        let symbol = newVal > itemAmount ? "+" : "-";
        let remainAmount = Math.abs(itemAmount - newVal);
        
        // Update the data attributes
        $input.attr("data-adjust_symbol", symbol);
        $input.attr("data-adjust_amount", remainAmount);
        
        // Store the current element data
        thisElement = {
            symbol: symbol,
            remainAmount: remainAmount,
            id: $input.data("id"),
            qty: $input.parents(".cart__item").find(".js-qty__num").val(),
        };
        
        // Store in pending updates with all necessary data
        pendingUpdates.set(itemKey, {
            key: itemKey,
            $input: $input,
            quantity: Number($input.parents(".cart__item").find(".js-qty__num").val() || 1),
            adjustAmount: remainAmount,
            adjustSymbol: symbol
        });
        
        // Update the display immediately (visual feedback only)
        adjustAmount(false);
        
        console.log('Price changed, waiting for blur/click outside to save...');
    });
    
    // FIXED: Call change.js only when input loses focus
    $(".adjust-value").on("blur", async function (e) {
        const $input = $(this);
        const itemKey = $input.parents(".cart__item").data("key");
        
        if (pendingUpdates.has(itemKey)) {
            console.log('Input blurred, updating cart...');
            isLoadingAdjuster = true;
            
            await updateSingleLineItem($input);
            
            pendingUpdates.delete(itemKey);
            isAmountAdjusting = false;
            isLoadingAdjuster = false;
            adjustAmount(false);
        }
    });
    
    // Checkout button handler
    $(document).on("click", "#myBtn", async function (e) {
        e.preventDefault();
        $(".customer_exist").removeClass('required')
        if($(".customer_exist").length > 0 && $(".customer_exist").val() == ""){
            $(".customer_exist").addClass('required').focus();
            return;
        }
        // Wait for any pending updates to complete
        if (pendingUpdates.size > 0) {
            await updateAllPendingLineItems();
        }
        
        initViriffCheckout();
    });
    
    $(document).on("click", "#myModalClose", function (e) {
        $("#myModal").hide();
    });
    
    // FIXED: Call change.js when clicking outside the input
    $(document).on("click", async function (e) {
        // Check if click is outside all adjust-value inputs
        if (!$(e.target).hasClass("adjust-value") && !$(e.target).closest(".adjust-value").length) {
            if (pendingUpdates.size > 0) {
                console.log('Clicked outside, updating all pending items...');
                await updateAllPendingLineItems();
            }
        }
    });
    
    // FIXED: Also update when switching to another adjust-value input
    $(document).on("focus", ".adjust-value", async function (e) {
        const currentKey = $(this).parents(".cart__item").data("key");
        
        // Update all pending items except the one being focused
        if (pendingUpdates.size > 0) {
            const itemsToUpdate = Array.from(pendingUpdates.values()).filter(item => item.key !== currentKey);
            
            if (itemsToUpdate.length > 0) {
                console.log('Switching to another input, updating previous item...');
                isLoadingAdjuster = true;
                
                for (const itemData of itemsToUpdate) {
                    await updateSingleLineItemFromData(itemData);
                    pendingUpdates.delete(itemData.key);
                }
                
                isLoadingAdjuster = false;
                adjustAmount(false);
            }
        }
    });
});

// Update a single line item from input element
async function updateSingleLineItem($input) {
    const itemKey = $input.parents(".cart__item").data("key");
    const quantity = Number($input.parents(".cart__item").find(".js-qty__num").val() || 1);
    const adjustAmount = $input.attr("data-adjust_amount");
    const adjustSymbol = $input.attr("data-adjust_symbol");
    
    try {
        console.log('Calling /cart/change.js for item:', itemKey);
        
        const response = await fetch('/cart/change.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                id: itemKey,
                quantity: quantity,
                properties: {
                    _adjust_amount: adjustAmount,
                    _adjust_symbol: adjustSymbol
                }
            })
        });
        
        const result = await response.json();
        
        if (result.status === 'bad_request') {
            console.error('Cart update error:', result.message);
            return null;
        }
        
        console.log('Item updated successfully:', result);
        return result;
    } catch (error) {
        console.error('Error updating item:', error);
        return null;
    }
}

// Update a single line item from stored data
async function updateSingleLineItemFromData(itemData) {
    try {
        console.log('Calling /cart/change.js for item:', itemData.key);
        
        const response = await fetch('/cart/change.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                id: itemData.key,
                quantity: itemData.quantity,
                properties: {
                    _adjust_amount: itemData.adjustAmount,
                    _adjust_symbol: itemData.adjustSymbol
                }
            })
        });
        
        const result = await response.json();
        
        if (result.status === 'bad_request') {
            console.error('Cart update error:', result.message);
            return null;
        }
        
        console.log('Item updated successfully:', result);
        return result;
    } catch (error) {
        console.error('Error updating item:', error);
        return null;
    }
}

// Update all pending line items
async function updateAllPendingLineItems() {
    if (pendingUpdates.size === 0) return;
    
    isLoadingAdjuster = true;
    isAmountAdjusting = true;
    
    console.log('Updating', pendingUpdates.size, 'pending items...');
    
    // Update all pending items sequentially
    for (const [key, itemData] of pendingUpdates.entries()) {
        await updateSingleLineItemFromData(itemData);
    }
    
    // Clear state
    pendingUpdates.clear();
    isAmountAdjusting = false;
    thisElement = null;
    isLoadingAdjuster = false;
    adjustAmount(false);
    
    console.log('All pending updates completed');
}



async function initViriffCheckout() {
    let oldBtnText = $("#myBtn").html();
    $("#myBtn").attr("disabled", "true").html('Please wait...');

    await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          'Customers email address': $("#client-email").val()   
        }
      })
    });
    
    if (isAmountAdjusting || pendingUpdates.size > 0) {
        setTimeout(() => {
            initViriffCheckout();
        }, 500);
        return false;
    }

    if (ShopifyAnalytics.meta.page.customerId && (isAmountAdjust || $(".shipping-line-item--radio input[type='radio']:checked").val() == "Click and collect")) {

        $.getJSON("/cart.js", function (data) {

            $.post("https://goldunion.codevibez.com/veriff/index.php", {
                shop: "goldunion-us.myshopify.com",
                customer: ShopifyAnalytics.meta.page.customerId ?? "",
                cart: data,
                email: $("#client-email").val(),
                shipping: {
                    name: $(".shipping-line-item--radio input[type='radio']").length > 0 ? $(".shipping-line-item--radio input[type='radio']:checked").val() : "",
                    agent: $("#agency-id").length > 0 ? $("#agency-id").val() : "",
                },
            }, (result) => {
                window.location = result.order.invoice_url;
            });

        });

    } else {
        window.location = window.location.origin + "/checkout";
    }
}

function adjustAmount(updateValue) {
    let addedAmount = 0;
    isAmountAdjust = false;
    
    if ($(".adjust-value").length > 0) {
        isFistTimePageLoad = false;
        
        $(".adjust-value").each(function () {
            let symbol = $(this).attr("data-adjust_symbol") || "";
            let amount = parseFloat($(this).attr("data-adjust_amount")) || 0;
            let itemAmount = parseFloat($(this).attr("data-value")) || 0;
            let amt = 0;
            
            if (amount > 0) {
                isAmountAdjust = true;
            }
            
            let qty = parseInt($(this).parents(".cart__item").find(".js-qty__num").val()) || 1;
            
            if (symbol == "+") {
                amt += amount;
                itemAmount += amount;
            } else if (symbol == "-") {
                amt -= amount;
                itemAmount -= amount;
            }
            
            addedAmount += amt * qty;
            
            if ($(".cart__drawer-form").length > 0) {
                $(this).parents(".cart__item").find(".pricediv").html(theme.Currency.formatMoney(itemAmount * 100));
            }
            
            if (updateValue) $(this).val(itemAmount);
        });
        
        $("#main--shipping-div").hide();
        if (isAmountAdjust) {
            $("#main--shipping-div").show();
        }
        
        let cartTotalItem = $(".main__cart__item-sub--subtotal");
        let total = theme.Currency.formatMoney(parseInt(cartTotalItem.data("total")) + addedAmount * 100);
        
        $(".main__cart__item-sub--subtotal-adjust").remove();
        $(".cart__item--subtotal--adjust").append('<div class="main__cart__item-sub--subtotal-adjust"></div>');
        $(".main__cart__item-sub--subtotal--adjust").hide();
        
        if ($(".main__cart__item-sub--subtotal-adjust").length > 0) {
            $(".main__cart__item-sub--subtotal-adjust").html(total);
            return;
        }
        
        if ($(".cart__drawer-form").length > 0) {
            $(".cart__drawer-form .main__cart__item-sub--subtotal .wholesale-cart-total span").html(total);
            return;
        }
    }
}


function validatePhoneNumber(input_str) {
    var re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
    return re.test(input_str);
}

function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
        return parts.pop().split(";").shift();
    }
    return "";
}

let agencyClosures = [];

const csvUrl = window.agencyCsvUrl;

fetch(csvUrl)
  .then(response => {
    if (!response.ok) {
      throw new Error("HTTP " + response.status);
    }
    return response.text();
  })
  .then(csv => {

    const rows = csv.trim().split(/\r?\n/);

    // Detect separator automatically
    const separator = rows[0].includes(";") ? ";" : ",";

    // Remove header
    rows.shift();

    agencyClosures = rows
      .filter(row => row.trim() !== "")
      .map(row => {
         const cols = row.split(separator);

        return {
          "Agence": (cols[0] || "").trim(),
          "Date Fermeture": (cols[1] || "").trim(),
          "Date réouverture": (cols[2] || "").trim()
        };
      });

    // console.log("Agency Closures:", agencyClosures.length);
    //  console.table(agencyClosures);
     $("#datepic_client_date, #second_datepic_client_date").datepicker("refresh");
  })
  .catch(console.error);



function convertFrenchDate(value) {
    if (!value) return null;

    value = value.toString().trim();

    // dd-mm-yy
    if (/^\d{2}-\d{2}-\d{2}$/.test(value)) {
        const p = value.split("-");

        return new Date(
            2000 + parseInt(p[2], 10),   // year
            parseInt(p[1], 10) - 1,      // month
            parseInt(p[0], 10)           // day
        );
    }

    // yyyy-mm-dd
    if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
        const p = value.split("-");

        return new Date(
            parseInt(p[0], 10),
            parseInt(p[1], 10) - 1,
            parseInt(p[2], 10)
        );
    }

    // dd/mm/yyyy
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(value)) {
        const p = value.split("/");

        return new Date(
            parseInt(p[2], 10),
            parseInt(p[1], 10) - 1,
            parseInt(p[0], 10)
        );
    }

    return new Date(value);
}

function parseBookingDate(value) {
    if (!value) return null;
    value = value.trim();
    // yyyy-mm-dd
    if (value.indexOf("-") > -1) {
        const p = value.split("-");
        return new Date(
            parseInt(p[0], 10),
            parseInt(p[1], 10) - 1,
            parseInt(p[2], 10)
        );
    }
    // dd/mm/yyyy
    if (value.indexOf("/") > -1) {
        const p = value.split("/");
        return new Date(
            parseInt(p[2], 10),
            parseInt(p[1], 10) - 1,
            parseInt(p[0], 10)
        );
    }
    return new Date(value);
}

function normalizeAgency(name) {
    return name
        .toString()
        .toLowerCase()
        .replace(/📞.*$/, "")          // Remove everything after 📞
        .replace(/\d+/g, "")          // Remove numbers
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/-/g, " ")
        .replace(/\s+/g, " ")
        .trim();
}

function isAgencyClosed(agency, bookingDate) {

    // console.log("========== isAgencyClosed ==========");
    // console.log("Agency Input:", agency);
    // console.log("Booking Date:", bookingDate);

    if (!agency || !bookingDate) {
        console.log("Missing agency/date");
        return { status: false };
    }

    const selectedAgency = normalizeAgency(agency);

    // console.log("Normalized Agency:", selectedAgency);

    const selectedDate = $.datepicker.parseDate("yy-mm-dd", bookingDate);
    selectedDate.setHours(0,0,0,0);
    const selectedTime = selectedDate.getTime();

    // console.log("Rows:", agencyClosures.length);

    for (const row of agencyClosures) {

        const csvAgency = normalizeAgency(row["Agence"]);

        // console.log("----------------------------");
        // console.log("CSV:", csvAgency);
        // console.log("Selected:", selectedAgency);
        // console.log("Equal:", csvAgency === selectedAgency);

        if (csvAgency !== selectedAgency) {
            continue;
        }

        const closeDate = convertFrenchDate(row["Date Fermeture"]);
        const reopenDate = convertFrenchDate(row["Date réouverture"]);

        closeDate.setHours(0,0,0,0);
        reopenDate.setHours(0,0,0,0);

        // console.log("Close:", closeDate);
        // console.log("Reopen:", reopenDate);
        // console.log("Booking:", selectedDate);

        if (selectedTime >= closeDate.getTime() &&
            selectedTime < reopenDate.getTime()) {

            console.log("🚫 CLOSED");

            return {
                status: true,
                close: closeDate,
                reopen: reopenDate,
                row: row
            };
        }
    }

    // console.log("✅ AVAILABLE");

    return {
        status:false
    };
}

function isDateDisabled(date, agency) {
    const selectedAgency = normalizeAgency(agency);

    date.setHours(0, 0, 0, 0);

    for (const row of agencyClosures) {

        if (normalizeAgency(row["Agence"]) !== selectedAgency) continue;

        const closeDate = convertFrenchDate(row["Date Fermeture"]);
        const reopenDate = convertFrenchDate(row["Date réouverture"]);

        closeDate.setHours(0,0,0,0);
        reopenDate.setHours(0,0,0,0);

        if (date >= closeDate && date < reopenDate) {
            return true; // Disable
        }
    }

    return false;
}


/* ==========================================================
   PHONE HELPERS (US)
========================================================== */

/* Allow only digits, + space . - ( ) while typing (no length cap) */
$(document).on('input', '.custom_mobile_fileds', function () {
    this.value = this.value.replace(/[^\d+\s.\-()]/g, '');
});

function getItiInstance(input) {
    return (window.intlTelInputGlobals && intlTelInputGlobals.getInstance)
        ? intlTelInputGlobals.getInstance(input)
        : null;
}

/**
 * Normalizes and validates the phone number.
 * Returns { valid: bool, e164: '+15595551234', dial: '+1' }
 */
function validatePhoneInput($form) {

    var DEFAULT_DIAL = '+1';

    var input  = $form.find('.custom_mobile_fileds')[0];
    var result = { valid: false, e164: '', dial: '' };

    if (!input) return result;

    // Strip spaces, dots, dashes, parentheses
    var d = String(input.value || '').replace(/[\s.\-()]/g, '');

    // Only digits and an optional leading "+"
    if (!d || !/^\+?\d+$/.test(d)) return result;

    // 001559... -> +1559...
    if (d.indexOf('00') === 0) d = '+' + d.slice(2);

    var iti  = getItiInstance(input);
    var dial = ($form.find('.iti__selected-dial-code').text() || '').trim();

    if (iti && iti.getSelectedCountryData && iti.getSelectedCountryData().dialCode) {
        dial = '+' + iti.getSelectedCountryData().dialCode;
    }

    if (!dial) dial = DEFAULT_DIAL;

    // +44 (0)7700... / +33 (0)6... -> without the (0)
    if ((dial === '+44' || dial === '+33') && d.indexOf(dial + '0') === 0) {
        d = dial + d.slice(dial.length + 1);
    }

    /* ---- Preferred path: intl-tel-input with utils loaded ---- */
    if (iti && window.intlTelInputUtils && typeof iti.isValidNumber === 'function') {

        iti.setNumber(d);

        if (iti.isValidNumber()) {
            result.valid = true;
            result.e164  = iti.getNumber();
            result.dial  = '+' + iti.getSelectedCountryData().dialCode;
        }

        return result;
    }

    /* ---- Fallback without utils ---- */
    var national;

    if (d.charAt(0) === '+') {
        if (d.indexOf(dial) !== 0) return result;
        national = d.slice(dial.length);
    } else {
        national = d;
    }

    if (dial === '+1') {
        // US/Canada: optional leading 1, then 10 digits (area code and exchange start with 2-9)
        if (national.length === 11 && national.charAt(0) === '1') national = national.slice(1);
        if (!/^[2-9]\d{2}[2-9]\d{6}$/.test(national)) return result;

    } else if (dial === '+39') {
        if (!/^(3\d{8,9}|0\d{5,10})$/.test(national)) return result;

    } else if (dial === '+44') {
        if (national.charAt(0) === '0') national = national.slice(1);
        if (!/^[1-9]\d{8,9}$/.test(national)) return result;

    } else if (dial === '+33') {
        if (national.charAt(0) === '0') national = national.slice(1);
        if (!/^[1-9]\d{8}$/.test(national)) return result;

    } else {
        if (national.charAt(0) === '0') national = national.slice(1);
        if (!/^\d{6,12}$/.test(national)) return result;
    }

    result.valid = true;
    result.e164  = dial + national;
    result.dial  = dial;

    return result;
}


async function sendContactFormAction(formSelector) {

    var form = document.querySelector(formSelector);

    if (!form) {
        console.error("Form not found:", formSelector);
        return false;
    }

    var $form = $(formSelector);

    // Use only the button belonging to this form
    var $submitButton = $form.find(".brn-contact-form-submit");


    /* =========================================================
       PREVENT DUPLICATE SUBMISSION
    ========================================================= */

    if ($submitButton.attr("data-booking-submitted") === "true") {
        console.log("Booking already submitted. Preventing duplicate submission.");
        return false;
    }

    if ($submitButton.attr("data-booking-submitting") === "true") {
        console.log("Booking submission already in progress.");
        return false;
    }


    /* =========================================================
       DATE
    ========================================================= */

    var dateofbith = "";

    if (formSelector === ".sendContactFormAgent") {
        dateofbith = form.querySelector("#formatted_date")?.value || "";
    } else {
        dateofbith = form.querySelector("#second_formatted_date")?.value || "";
    }

    var meeting_time = $form.find("select[name='client_time']").val() || "";


    /* =========================================================
       BASIC VALIDATION
    ========================================================= */

    var phoneResult = validatePhoneInput($form);

    if (!phoneResult.valid) {

        $form
            .find(".contact-error-message")
            .text("Please enter a valid phone number (e.g. (559) 555-1234).")
            .show();

        $form.find(".mobile_label_input").addClass("mobile-error-show");

        $form.find(".date-error-message").hide();
        $form.find(".date_main-wrapp").removeClass("mobile-error-show");

        $form.find(".time-error-message").hide();
        $form.find(".time_main-wrapp").removeClass("mobile-error-show");

        return false;
    }


    if (!dateofbith) {

        $form.find(".date-error-message").show().text("Please enter Date");
        $form.find(".date_main-wrapp").addClass("mobile-error-show");

        $form.find(".contact-error-message").hide();
        $form.find(".mobile_label_input").removeClass("mobile-error-show");

        $form.find(".time-error-message").hide();
        $form.find(".time_main-wrapp").removeClass("mobile-error-show");

        return false;
    }


    // Works for value="Heure" and value=""
    if (!meeting_time || meeting_time === "Heure") {

        $form.find(".time-error-message").show();
        $form.find(".time_main-wrapp").addClass("mobile-error-show");

        $form.find(".date-error-message").hide();
        $form.find(".date_main-wrapp").removeClass("mobile-error-show");

        $form.find(".contact-error-message").hide();
        $form.find(".mobile_label_input").removeClass("mobile-error-show");

        return false;
    }


    /* =========================================================
       AGENCY HOLIDAY VALIDATION
    ========================================================= */

    var data_handle =
        $form.closest(".tab_data_main").attr("data-handle") || "";

    var agency = "";

    if (data_handle === "En agence") {

        agency = $form.find("#agency-id option:selected").val() || "";

        if (agency && dateofbith) {

            var holiday = isAgencyClosed(agency, dateofbith);

            if (holiday && holiday.status) {

                $form
                    .find(".date-error-message")
                    .show()
                    .text(
                        "This agency is closed from " +
                        $.datepicker.formatDate("dd/mm/yy", holiday.close) +
                        " to " +
                        $.datepicker.formatDate("dd/mm/yy", holiday.reopen)
                    );

                $form.find(".date_main-wrapp").addClass("mobile-error-show");

                return false;
            }
        }
    }


    /* =========================================================
       CLEAR ERRORS
    ========================================================= */

    $form.find(".contact-error-message").hide();
    $form.find(".mobile_label_input").removeClass("mobile-error-show");
    $form.find(".date-error-message").hide();
    $form.find(".date_main-wrapp").removeClass("mobile-error-show");
    $form.find(".time-error-message").hide();
    $form.find(".time_main-wrapp").removeClass("mobile-error-show");


    /* =========================================================
       LOCK SUBMIT BUTTON
    ========================================================= */

    $submitButton
        .attr("data-booking-submitting", "true")
        .prop("disabled", true)
        .html("Confirming your appointment ...");


    /* =========================================================
       API SETTINGS
    ========================================================= */

    var formAction = "https://goldunion.codevibez.com/api/contact";

    var hubspotAction =
        "https://api.hsforms.com/submissions/v3/integration/submit/147218200/00f5ba66-125b-4bf4-ad54-7eb055d4ed7b";

    var formData = new FormData(form);

    // Use the normalized E.164 number everywhere (API + HubSpot)
    formData.set("contact", phoneResult.e164);       // e.g. +15595551234

    var countryCode = phoneResult.dial;              // e.g. +1

    var object = {
        country_code: countryCode,
        shop: "goldunion-us.myshopify.com"
    };

    formData.forEach(function (value, key) {
        object[key] = value;
    });

    // Make sure the normalized values win
    object.contact      = phoneResult.e164;
    object.country_code = phoneResult.dial;

    var json = JSON.stringify(object);


    /* =========================================================
       HUBSPOT (OPTIONAL EXTRA, NEVER AFFECTS THE BOOKING)

       This runs only AFTER the booking is saved and the customer
       has seen the success message. If an ad blocker or a network
       drop makes it fail, the failure is only logged in the console.
    ========================================================= */

    async function sendToHubSpot() {

        try {

            var hutk = "";

            try {
                hutk = getCookie("hubspotutk") || "";
            } catch (e) {}

            var ipAddress = "";

            try {
                var ipRes = await fetch("https://api.ipify.org?format=json");
                var ipData = await ipRes.json();
                ipAddress = ipData.ip || "";
            } catch (e) {
                console.warn("Could not resolve IP address", e);
            }

            var hubspotPayload = {

                submittedAt: Date.now(),

                fields: [
                    { name: "firstname", value: formData.get("fname") || "" },
                    { name: "lastname", value: formData.get("lname") || "" },
                    { name: "email", value: formData.get("email") || "" },
                    { name: "phone", value: formData.get("contact") || "" },
                    { name: "agent", value: formData.get("agent") || "" },
                    { name: "pattern_sell_buy", value: formData.get("pattern") || "" },
                    { name: "client_date_01", value: formData.get("client_date") || "" },
                    { name: "client_time", value: formData.get("client_time") || "" },
                    {
                        name: "privacy_policy",
                        value: formData.get("privacy_policy") ? "true" : "false"
                    },
                    { name: "country_code", value: countryCode },
                    { name: "shop", value: "http://goldunion-us.myshopify.com/" }
                ].filter(function (field) {
                    return field.value !== "";
                }),

                context: {
                    pageUri: window.location.href,
                    pageName: document.title,
                    ...(hutk ? { hutk: hutk } : {}),
                    ...(ipAddress ? { ipAddress: ipAddress } : {})
                }
            };

            var hsResponse = await fetch(hubspotAction, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(hubspotPayload),
                keepalive: true
            });

            if (!hsResponse.ok) {
                console.warn("HubSpot returned an error:", hsResponse.status);
            }

        } catch (hubspotError) {

            // Customer must never see this. Booking already exists.
            console.warn("HubSpot submission failed (booking is saved):", hubspotError);
        }
    }


    /* =========================================================
       SEND BOOKING TO CODEVIBEZ
    ========================================================= */

    try {

        var customResponse = await fetch(formAction, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: json
        });

        // A server failure (500, 404, etc.) must NOT count as success
        if (!customResponse.ok) {
            throw new Error("HTTP error: " + customResponse.status);
        }

        var customResult = await customResponse.json();


        /* ---------- API explicitly reported an error ---------- */

        if (customResult.status === "error") {

            console.error("CUSTOM API ERROR:", customResult);

            // Safe to retry: the server said the booking was not created
            $submitButton
                .removeAttr("data-booking-submitting")
                .prop("disabled", false)
                .html("Confirm my appointment");

            $form
                .find(".note--success")
                .addClass("error")
                .removeClass("success")
                .html(customResult.message || "An error occurred. Please try again.")
                .show();

            return false;
        }


        /* ---------- SUCCESS ---------- */

        // Button stays disabled so the same appointment
        // cannot be submitted twice.
        $submitButton
            .removeAttr("data-booking-submitting")
            .attr("data-booking-submitted", "true")
            .prop("disabled", true)
            .html("Appointment confirmed");

        $form
            .find(".note--success")
            .addClass("success")
            .removeClass("error")
            .html(customResult.message || "Your appointment has been confirmed.")
            .show();


        /* ---------- AGENCY / ADDRESS ---------- */

        var agency_name = "";

        if (data_handle === "En agence") {
            agency_name = $form.find("#agency-id option:selected").val() || "";
        } else {
            agency_name = $form.find("#search_input").val() || "";
        }


        /* ---------- GOOGLE ANALYTICS ---------- */

        var data_currency = $("html").attr("currency");

        if (typeof gtag === "function") {

            gtag("event", "conversion", {
                send_to: "G-MTHYR484J8",
                "Home or Agency": data_handle,
                "Agency name (city)": agency_name,
                currency: data_currency
            });
        }


        /* ---------- HUBSPOT (best effort, not awaited) ---------- */

        sendToHubSpot();


    } catch (error) {

        console.error("Appointment submission error:", error);

        // The request may have reached the server, so keep the button
        // disabled to avoid creating a duplicate appointment.
        $submitButton
            .removeAttr("data-booking-submitting")
            .attr("data-booking-submitted", "true")
            .prop("disabled", true)
            .html("Check your appointment");

        $form
            .find(".note--success")
            .addClass("error")
            .removeClass("success")
            .html(
                "The status of your appointment is uncertain. Please check your appointment before trying again."
            )
            .show();
    }


    return false;
}


// async function sendContactFormAction(formSelector) {

//     var form = document.querySelector(formSelector);

//     if (!form) {
//         console.error("Form not found:", formSelector);
//         return false;
//     }

//     var $form = $(formSelector);

//     // Use only the button belonging to this form
//     var $submitButton = $form.find(".brn-contact-form-submit");


//     /* =========================================================
//        PREVENT DUPLICATE SUBMISSION
//     ========================================================= */

//     if ($submitButton.attr("data-booking-submitted") === "true") {
//         console.log("Booking already submitted. Preventing duplicate submission.");
//         return false;
//     }

//     if ($submitButton.attr("data-booking-submitting") === "true") {
//         console.log("Booking submission already in progress.");
//         return false;
//     }


//     var phone = $form.find(".custom_mobile_fileds").val() || "";


//     /* =========================================================
//        DATE
//     ========================================================= */

//     var dateofbith = "";

//     if (formSelector === ".sendContactFormAgent") {
//         dateofbith = form.querySelector("#formatted_date")?.value || "";
//     } else {
//         dateofbith = form.querySelector("#second_formatted_date")?.value || "";
//     }

//     var meeting_time = $form.find("select[name='client_time']").val() || "";


//     /* =========================================================
//        BASIC VALIDATION
//     ========================================================= */

//     if (!validatePhoneNumber(phone)) {

//         $form.find(".contact-error-message").show();
//         $form.find(".mobile_label_input").addClass("mobile-error-show");

//         $form.find(".date-error-message").hide();
//         $form.find(".date_main-wrapp").removeClass("mobile-error-show");

//         $form.find(".time-error-message").hide();
//         $form.find(".time_main-wrapp").removeClass("mobile-error-show");

//         return false;
//     }


//     if (!dateofbith) {

//         $form.find(".date-error-message").show().text("Please enter Date");
//         $form.find(".date_main-wrapp").addClass("mobile-error-show");

//         $form.find(".contact-error-message").hide();
//         $form.find(".mobile_label_input").removeClass("mobile-error-show");

//         $form.find(".time-error-message").hide();
//         $form.find(".time_main-wrapp").removeClass("mobile-error-show");

//         return false;
//     }


//     // Works for value="Heure" and value=""
//     if (!meeting_time || meeting_time === "Heure") {

//         $form.find(".time-error-message").show();
//         $form.find(".time_main-wrapp").addClass("mobile-error-show");

//         $form.find(".date-error-message").hide();
//         $form.find(".date_main-wrapp").removeClass("mobile-error-show");

//         $form.find(".contact-error-message").hide();
//         $form.find(".mobile_label_input").removeClass("mobile-error-show");

//         return false;
//     }


//     /* =========================================================
//        AGENCY HOLIDAY VALIDATION
//     ========================================================= */

//     var data_handle =
//         $form.closest(".tab_data_main").attr("data-handle") || "";

//     var agency = "";

//     if (data_handle === "En agence") {

//         agency = $form.find("#agency-id option:selected").val() || "";

//         if (agency && dateofbith) {

//             var holiday = isAgencyClosed(agency, dateofbith);

//             if (holiday && holiday.status) {

//                 $form
//                     .find(".date-error-message")
//                     .show()
//                     .text(
//                         "This agency is closed from " +
//                         $.datepicker.formatDate("dd/mm/yy", holiday.close) +
//                         " to " +
//                         $.datepicker.formatDate("dd/mm/yy", holiday.reopen)
//                     );

//                 $form.find(".date_main-wrapp").addClass("mobile-error-show");

//                 return false;
//             }
//         }
//     }


//     /* =========================================================
//        CLEAR ERRORS
//     ========================================================= */

//     $form.find(".contact-error-message").hide();
//     $form.find(".mobile_label_input").removeClass("mobile-error-show");
//     $form.find(".date-error-message").hide();
//     $form.find(".date_main-wrapp").removeClass("mobile-error-show");
//     $form.find(".time-error-message").hide();
//     $form.find(".time_main-wrapp").removeClass("mobile-error-show");


//     /* =========================================================
//        LOCK SUBMIT BUTTON
//     ========================================================= */

//     $submitButton
//         .attr("data-booking-submitting", "true")
//         .prop("disabled", true)
//         .html("Confirming your appointment ...");


//     /* =========================================================
//        API SETTINGS
//     ========================================================= */

//     var formAction = "https://goldunion.codevibez.com/api/contact";

//     var hubspotAction =
//         "https://api.hsforms.com/submissions/v3/integration/submit/147218200/00f5ba66-125b-4bf4-ad54-7eb055d4ed7b";

//     var formData = new FormData(form);

//     var countryCode = $form.find(".iti__selected-dial-code").html() || "";

//     var object = {
//         country_code: countryCode,
//         shop: "goldunion-us.myshopify.com"
//     };

//     formData.forEach(function (value, key) {
//         object[key] = value;
//     });

//     var json = JSON.stringify(object);


//     /* =========================================================
//        HUBSPOT (OPTIONAL EXTRA, NEVER AFFECTS THE BOOKING)

//        This runs only AFTER the booking is saved and the customer
//        has seen the success message. If an ad blocker or a network
//        drop makes it fail, the failure is only logged in the console.
//     ========================================================= */

//     async function sendToHubSpot() {

//         try {

//             var hutk = "";

//             try {
//                 hutk = getCookie("hubspotutk") || "";
//             } catch (e) {}

//             var ipAddress = "";

//             try {
//                 var ipRes = await fetch("https://api.ipify.org?format=json");
//                 var ipData = await ipRes.json();
//                 ipAddress = ipData.ip || "";
//             } catch (e) {
//                 console.warn("Could not resolve IP address", e);
//             }

//             var hubspotPayload = {

//                 submittedAt: Date.now(),

//                 fields: [
//                     { name: "firstname", value: formData.get("fname") || "" },
//                     { name: "lastname", value: formData.get("lname") || "" },
//                     { name: "email", value: formData.get("email") || "" },
//                     { name: "phone", value: formData.get("contact") || "" },
//                     { name: "agent", value: formData.get("agent") || "" },
//                     { name: "pattern_sell_buy", value: formData.get("pattern") || "" },
//                     { name: "client_date_01", value: formData.get("client_date") || "" },
//                     { name: "client_time", value: formData.get("client_time") || "" },
//                     {
//                         name: "privacy_policy",
//                         value: formData.get("privacy_policy") ? "true" : "false"
//                     },
//                     { name: "country_code", value: countryCode },
//                     { name: "shop", value: "http://goldunion-us.myshopify.com/" }
//                 ].filter(function (field) {
//                     return field.value !== "";
//                 }),

//                 context: {
//                     pageUri: window.location.href,
//                     pageName: document.title,
//                     ...(hutk ? { hutk: hutk } : {}),
//                     ...(ipAddress ? { ipAddress: ipAddress } : {})
//                 }
//             };

//             var hsResponse = await fetch(hubspotAction, {
//                 method: "POST",
//                 headers: { "Content-Type": "application/json" },
//                 body: JSON.stringify(hubspotPayload),
//                 keepalive: true
//             });

//             if (!hsResponse.ok) {
//                 console.warn("HubSpot returned an error:", hsResponse.status);
//             }

//         } catch (hubspotError) {

//             // Customer must never see this. Booking already exists.
//             console.warn("HubSpot submission failed (booking is saved):", hubspotError);
//         }
//     }


//     /* =========================================================
//        SEND BOOKING TO CODEVIBEZ
//     ========================================================= */

//     try {

//         var customResponse = await fetch(formAction, {
//             method: "POST",
//             headers: { "Content-Type": "application/json" },
//             body: json
//         });

//         // A server failure (500, 404, etc.) must NOT count as success
//         if (!customResponse.ok) {
//             throw new Error("HTTP error: " + customResponse.status);
//         }

//         var customResult = await customResponse.json();


//         /* ---------- API explicitly reported an error ---------- */

//         if (customResult.status === "error") {

//             console.error("CUSTOM API ERROR:", customResult);

//             // Safe to retry: the server said the booking was not created
//             $submitButton
//                 .removeAttr("data-booking-submitting")
//                 .prop("disabled", false)
//                 .html("Confirm my appointment");

//             $form
//                 .find(".note--success")
//                 .addClass("error")
//                 .removeClass("success")
//                 .html(customResult.message || "An error occurred. Please try again.")
//                 .show();

//             return false;
//         }


//         /* ---------- SUCCESS ---------- */

//         // Button stays disabled so the same appointment
//         // cannot be submitted twice.
//         $submitButton
//             .removeAttr("data-booking-submitting")
//             .attr("data-booking-submitted", "true")
//             .prop("disabled", true)
//             .html("Appointment confirmed");

//         $form
//             .find(".note--success")
//             .addClass("success")
//             .removeClass("error")
//             .html(customResult.message || "Your appointment has been confirmed.")
//             .show();


//         /* ---------- AGENCY / ADDRESS ---------- */

//         var agency_name = "";

//         if (data_handle === "En agence") {
//             agency_name = $form.find("#agency-id option:selected").val() || "";
//         } else {
//             agency_name = $form.find("#search_input").val() || "";
//         }


//         /* ---------- GOOGLE ANALYTICS ---------- */

//         var data_currency = $("html").attr("currency");

//         if (typeof gtag === "function") {

//             gtag("event", "conversion", {
//                 send_to: "G-MTHYR484J8",
//                 "Home or Agency": data_handle,
//                 "Agency name (city)": agency_name,
//                 currency: data_currency
//             });
//         }


//         /* ---------- HUBSPOT (best effort, not awaited) ---------- */

//         sendToHubSpot();


//     } catch (error) {

//         console.error("Appointment submission error:", error);

//         // The request may have reached the server, so keep the button
//         // disabled to avoid creating a duplicate appointment.
//         $submitButton
//             .removeAttr("data-booking-submitting")
//             .attr("data-booking-submitted", "true")
//             .prop("disabled", true)
//             .html("Check your appointment");

//         $form
//             .find(".note--success")
//             .addClass("error")
//             .removeClass("success")
//             .html(
//                 "The status of your appointment is uncertain. Please check your appointment before trying again."
//             )
//             .show();
//     }


//     return false;
// }







// ============================================
// GOOGLE MAPS AUTOCOMPLETE
// ============================================
var searchInput = "search_input";
$(document).ready(function () {
    var autocomplete;
    autocomplete = new google.maps.places.Autocomplete(document.getElementById(searchInput), {
        types: ["geocode"],
        componentRestrictions: {
            country: "fr"
        }
    });
    google.maps.event.addListener(autocomplete, "place_changed", function () {
        var near_place = autocomplete.getPlace();
        if (document.getElementById("loc_lat"))
            document.getElementById("loc_lat").value = near_place.geometry.location.lat();
        if (document.getElementById("loc_long"))
            document.getElementById("loc_long").value = near_place.geometry.location.lng();
        if (document.getElementById("latitude_view"))
            document.getElementById("latitude_view").innerHTML = near_place.geometry.location.lat();
        if (document.getElementById("longitude_view"))
            document.getElementById("longitude_view").innerHTML = near_place.geometry.location.lng();
    });
});

$(document).on("change", "#" + searchInput, function () {
    if (document.getElementById("latitude_input"))
        document.getElementById("latitude_input").value = "";
    if (document.getElementById("longitude_input"))
        document.getElementById("longitude_input").value = "";
    if (document.getElementById("latitude_view"))
        document.getElementById("latitude_view").innerHTML = "";
    if (document.getElementById("longitude_view"))
        document.getElementById("longitude_view").innerHTML = "";
});

// ============================================
// SHIPPING AND ACCORDION HANDLERS
// ============================================
$(document).on("change", ".shipping-line-item--radio input[type='radio']", function () {
    $(".agent-dropdown").hide();
    if ($(this).data("agent") == true) {
        $(this).parents(".shipping-line-item--radio").find(".agent-dropdown").show();
    }
});

$(document).on("click", ".accordion-section-wrapper-main .custom_accordion-btn", function () {
    $(this).parents(".accordion-section-wrapper-main").find(".accordion-section-content_last").slideToggle();
});